
import { Options, Vue } from "vue-class-component";
@Options({})
export default class App extends Vue {
  getWidthDevice() {
    const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    return width;
  }
}
